<template>
  <div style="height:100%">
    <v-row justify="center" class="mt-7">
      <v-col cols="12" lg="10" md="10" sm="12" xs="12">
        <TrackTable />
      </v-col>
    </v-row>
    <!-- <new-track/> -->
  </div>
</template>

<script>
// import NewTrack from "@/components/atoms/tracks/NewTrack.vue";
import TrackTable from "@/components/molecules/TrackTable.vue";

export default {
  components: {
    // NewTrack,
    TrackTable,
  },
};
</script>
